import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import classnames from 'classnames'

import styles from './image-preview.css'

import CrossIcon from '../../../../../assets/icons/cross.svg'

const ImagePreview = ({ isUploadingImage, imagePreview, onClick }) => (
  <div>
    <div styleName={classnames('image', { uploading: isUploadingImage })}>
      <img alt="" src={imagePreview} styleName="preview" />
      <button styleName="button" onClick={onClick}>
        <CrossIcon />
      </button>
    </div>
  </div>
)

ImagePreview.propTypes = {
  isUploadingImage: PropTypes.bool,
  imagePreview: PropTypes.string,
  onClick: PropTypes.func,
}

export default CSSModules(ImagePreview, styles, { allowMultiple: true })



/** WEBPACK FOOTER **
 ** ./src/components/setupform-form/field/image-input/image-preview.js
 **/